import { useQuery } from '@tanstack/react-query';

import { exercisesService } from '../services';

import { clientExercisesKeys } from './useExercises';

export function useClientExerciseDetail(
  clientId: string | undefined,
  clientExerciseId: string | undefined,
) {
  return useQuery({
    queryKey: clientExercisesKeys.operation('detail', {
      clientId: clientId ?? '',
      cxId: clientExerciseId ?? '',
    }),
    queryFn: () => {
      if (!clientId || !clientExerciseId) throw new Error('missing id');
      return exercisesService.getClientExercise(clientId, clientExerciseId);
    },
    enabled: Boolean(clientId && clientExerciseId),
  });
}
